import {SvgIcon} from "@material-ui/core";

export const CustomBookBookmarkIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13.7502 2.5V10L11.2497 8.125L8.75024 10V2.5" stroke="#424242" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.75024 16.875C3.75024 16.3777 3.94779 15.9008 4.29942 15.5492C4.65105 15.1975 5.12796 15 5.62524 15H16.2502V2.5H5.62524C5.12796 2.5 4.65105 2.69754 4.29942 3.04917C3.94779 3.40081 3.75024 3.87772 3.75024 4.375V16.875Z" stroke="#424242" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.75024 16.875V17.5H15.0002" stroke="#424242" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
